import { BuildUrl } from "../../../helpers/ApiHelpers";

export const isValidLthCap = (cap: number | null) =>
	cap === null || (Number.isInteger(cap) && cap >= 0 && cap <= 2147483647);

export const saveLthCap = async (
	doctorId: number,
	cap: number | null,
	originalCap: number | null,
	headers: HeadersInit
) => {
	if (cap === originalCap) return;
	const response = await fetch(BuildUrl(`Doctor/${doctorId}/lth-capacity`), {
		method: "PUT",
		headers,
		body: JSON.stringify({ dailyCap: cap })
	});
	if (!response.ok) {
		throw new Error(response.status === 409
			? "The daily LTH cap changed. Reload the doctor before saving again."
			: "Could not save the daily LTH cap.");
	}
};
